<template>
    <div id="app" dark style="padding: 0px !important;">
        <!--TOOLBAR-->
        <v-toolbar flat app v-if="!this.$store.state.logged" class="white darken-1">
            <img style="max-height: 50px;padding: 2px;" src="/img/logo-ogg.png">
            <v-spacer></v-spacer>
        </v-toolbar>
      <!--  <img id="full-screen-background-image" src="../assets/03.jpg" style="padding: 0px !important;">-->

        <div id="overlay"></div>

        <v-container style="padding: 0px !important;max-width: 750px">

            <v-layout row wrap style="padding: 0px !important;">

                <v-flex xs12 sm8 offset-sm2 align-center justify-center>

                    <v-card class="text-xs-center transparent" flat style="margin:auto;margin-top: 35%;max-width: 600px;padding: 0px !important;">

                        <v-card-text style="padding: 4px !important;">

                            <v-toolbar flat class="transparent">
                                <h2 class="white--text">Gestor</h2>
                            </v-toolbar>

                            <v-container>

                                <v-progress-linear v-if="loading" v-bind:indeterminate="true" height="2" color="primary"></v-progress-linear>

                                <v-alert class="text-xs-left" flat color="error" icon="warning" :value="error">
                                    {{ message }}
                                </v-alert>

                                <v-alert class="text-xs-left" flat color="success" icon="check_circle" :value="success">
                                    {{ message }}
                                </v-alert>

                                <v-form v-if="setForm" v-model="valid" ref="form" lazy-validation v-on:submit.prevent="go">

                                    <v-text-field class="v-input__control " dark label="E-mail" v-model="email" :rules="rules" required></v-text-field>

                                    <v-text-field label="Password" dark v-model="password" :rules="rules" type="password" required></v-text-field>

                                    <v-btn type="submit" class="black darken-4" dark :disabled="!valid" flat>Acessar </v-btn>

                                    <v-btn @click="goRecovery" dark class="black darken-4" flat>Esqueci a senha </v-btn>

                                </v-form>

                                <v-form v-if="!setForm" v-model="valid" ref="form2" lazy-validation flex>
                                    <v-layout row>
                                        <v-flex xs12 md12 sm12>
                                            <v-text-field light v-if="!success" class="v-input__control " dark label="E-mail" v-model="email" :rules="rules" required></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex xs12 md12 sm12>
                                            <v-btn @click="backToLogin" flat dark class="black darken-4">
                                                Tentar novamente
                                            </v-btn>

                                            <v-btn @click="recovery" :disabled="!valid" v-if="!success" flat dark class="black darken-4">
                                                Recuperar sua senha
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-form>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<style scoped>

    .v-input__control {
        background-color: transparent !important;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        -webkit-transition: "color 9999s ease-out, background-color 9999s ease-out";
        -webkit-transition-delay: 9999s;
    }

    body, html{
        overflow: auto !important;
    }

    #overlay {
        opacity: 1.5;
        position: fixed; /* Sit on top of the page content */
        display: block; /* Hidden by default */
        width: 100%; /* Full width (cover the whole page) */
        height: 100%; /* Full height (cover the whole page) */
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.67); /* Black background with opacity */
        z-index: 0; /* Specify a stack order in case you're using a different order for other elements */

    }

    #app:before {
        content: ' ';
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 0;
        opacity: 1.3;
        background-image: url("/img/01.jpg");
        background-repeat: no-repeat;
        background-position: 50% 0;
        -ms-background-size: cover;
        -o-background-size: cover;
        -moz-background-size: cover;
        -webkit-background-size: cover;
        background-size: cover;
    }


</style>
<script>
    import * as Cookies from 'vue-cookie'

    export default {
        name: 'Auth',
        data: function () {
            return {
                setForm: true,
                snackbar: true,
                loading: false,
                email: 'rogerio.wcast@gmail.com',
                success: false,
                error: false,
                password: '',
                message: '',
                valid: false,
                rules: [
                    (v) => !!v || 'Este campo é obrigatório'
                ]
            }
        },
        methods: {
            backToLogin: function () {
                this.setForm = true
            },
            goRecovery: function () {
                this.setForm = false
                this.success = false
                this.error = false
            },
            go: function () {
                var self = this
                self.message = ''
                self.success = false
                self.error = false
                if (self.$refs.form.validate()) {
                    self.$store.commit('setLoading', true)
                    self.axios.post('/login.json', {email: self.email, password: self.password}, {
                        headers: {
                            'Authorization': ''
                        }
                    }).then((response) => {
                        self.$store.commit('setLoading', false)
                        if (response.data.success === true) {
                            self.$store.commit('authenticated', response.data)
                            Cookies.set('c_extra', JSON.stringify(response.data))
                            if (self.remember === true) {
                                Cookies.set('remember', JSON.stringify({email: self.email, password: self.password}), '1h')
                            } else {
                                Cookies.set('remember', '', 30)
                            }
                            self.$router.push('/')
                        } else {
                            self.error = true
                            self.message = response.data.message
                        }
                    }).catch(function (error) {
                        self.loading = false
                        if (error) {
                            self.error = true
                            self.message = 'Sua conexão está com problemas, tente novamente mais tarde!'
                        }
                    })
                }
            },
            recovery: function () {
                this.success = false
                this.error = false
                this.message = ''
                this.loading = true
                if (this.$refs.form2.validate()) {
                    this.axios.post('/recovery-password.json', {email: this.email, password: this.password}, {headers: {'Authorization': ''}}).then((response) => {
                        this.loading = false
                        if (response.data.success === true) {
                            this.success = true
                            this.message = response.data.message
                        } else {
                            this.error = true
                            this.message = response.data.message
                        }
                    })
                }
            }
        },
        mounted: function () {
            if (JSON.parse(Cookies.get('c_extra')) != null) {
                var session = JSON.parse(Cookies.get('c_extra'))
                if (session.token) {
                    // this.$router.push('/users')
                }
            }
        }
    }
</script>
